var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04378 16.5C1.49463 16.5 1.02453 16.3042 0.633466 15.9125C0.242405 15.5208 0.046875 15.05 0.046875 14.5V2.5C0.046875 1.95 0.242405 1.47917 0.633466 1.0875C1.02453 0.695833 1.49463 0.5 2.04378 0.5H7.21078C7.47703 0.5 7.73081 0.55 7.9721 0.65C8.21339 0.75 8.42556 0.891667 8.60861 1.075L10.0314 2.5H19.0175C19.3004 2.5 19.5375 2.59583 19.7289 2.7875C19.9203 2.97917 20.0159 3.21667 20.0159 3.5C20.0159 3.78333 19.9203 4.02083 19.7289 4.2125C19.5375 4.40417 19.3004 4.5 19.0175 4.5H5.88783C4.85609 4.5 3.95748 4.825 3.192 5.475C2.42652 6.125 2.04378 6.95 2.04378 7.95V14.5L4.01573 7.925C4.14885 7.49167 4.39431 7.14583 4.75209 6.8875C5.10987 6.62917 5.50509 6.5 5.93775 6.5H18.8178C19.5001 6.5 20.0367 6.77083 20.4278 7.3125C20.8189 7.85417 20.9229 8.44167 20.7398 9.075L18.9426 15.075C18.8095 15.5083 18.564 15.8542 18.2062 16.1125C17.8485 16.3708 17.4532 16.5 17.0206 16.5H2.04378Z",
    fill: "#5C4BB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentFile);
export default __webpack_public_path__ + "static/media/assessment-file.a42cf8ab2e485d70acaf4d79d1e9eae4.svg";
export { ForwardRef as ReactComponent };